import React from 'react';

const PaymentActions = ({ onClose, onConfirm, loadingState, selectedEmployee, selectedServices, resetGiftCards }) => {
  const isConfirmDisabled = loadingState === 'paying' || !selectedEmployee || selectedServices.length === 0;
  return (
    <div className="mt-4 flex justify-end space-x-4">
      <button
        onClick={
            ()=>{
                onClose()
                resetGiftCards()
            }
        }
        className="bg-gray-500 hover:bg-gray-600 text-white font-bold py-2 px-4 rounded-lg transition-transform transform hover:scale-105"
      >
        Cerrar
      </button>
      <button
        onClick={onConfirm}
        className={`bg-green-500 hover:bg-green-600 text-white font-bold py-2 px-4 rounded-lg transition-transform transform hover:scale-105 ${
          isConfirmDisabled ? 'opacity-50 cursor-not-allowed' : ''
        }`}
        disabled={isConfirmDisabled}
      >
        {loadingState === 'paying' ? 'Procesando...' : 'Confirmar Pago'}
      </button>
    </div>
  );
};

export default PaymentActions;
